'use client'

import { createContext, useContext } from 'react'

const CountriesContext = createContext([])

export function CountriesProvider({ countries, children }) {
    return (
        <CountriesContext.Provider value={countries}>
            {children}
        </CountriesContext.Provider>
    )
}

export function useCountries() {
    return useContext(CountriesContext)
}
